module.exports = __webpack_public_path__ + "media/images/pc/hokepon_reserve/content-ca3a2bddefc4a916874642a5deebe483.png";